import { useCallback, useState } from 'react';
import { UploadFile } from 'antd';
import { RcFile } from 'antd/es/upload';
import Joi from 'joi';

export const useFileUpload = (
  schema: Joi.ObjectSchema,
  onError?: (message: string, file: RcFile) => void,
  multiple = true,
) => {
  const [fileList, setFileList] = useState<RcFile[]>([]);

  const onBeforeUpload = useCallback(
    (file: RcFile) => {
      const { size, type } = file;
      const { error } = schema.validate({ size, type });
      if (error) {
        onError?.(error.message, file);
      } else {
        setFileList((prev) => (multiple ? [...prev, file] : [file]));
      }
      return false;
    },
    [onError, schema, multiple],
  );

  const onAfterUpload = useCallback(() => setFileList([]), []);

  const onRemove = useCallback(
    (file: UploadFile) =>
      setFileList((prev) => prev.filter(({ uid }) => uid !== file.uid)),
    [],
  );

  return {
    fileList,
    onBeforeUpload,
    onAfterUpload,
    onRemove,
  };
};
